// extracted by mini-css-extract-plugin
module.exports = {"defaultReset":"zoomable_defaultReset__bQ_Pt"};